import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getAggregatorResponse, initiateAccountAggregator } from '../../Utils/api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import JourneyRightPanel from '../../component/JourneyRightPannel';
import MobileNav from '../../component/MobileNav';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');

  .aa-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .aa-page {
    min-height: 100vh;
    background: #eaf1fd;
    font-family: 'Sora', sans-serif;
    display: flex;
    flex-direction: column;
  }

  /* ── SPLIT LAYOUT ── */
  .aa-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex: 1;
    min-height: calc(100vh - 60px);
    margin-top:50px;
  }

  /* ── LEFT ── */
  .aa-left {
    display: flex;
    flex-direction: column;
    padding: 3rem 3.5rem;
    background: #eaf1fd;
    overflow-y: auto;
  }

  
  /* CARD */
  .aa-card {
    background: #fff;
    border-radius: 24px;
    padding: 2.25rem 2.5rem 2rem;
    box-shadow: 0 4px 40px rgba(15,28,46,0.08), 0 1px 4px rgba(15,28,46,0.04);
    border: 1px solid rgba(255,255,255,0.8);
  }

  /* ICON RING */
  .aa-icon-ring {
    width: 56px; height: 56px; border-radius: 16px;
    background: rgba(55,138,221,0.1);
    border: 1.5px solid rgba(55,138,221,0.2);
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.25rem;
  }
  .aa-icon-ring svg { width: 26px; height: 26px; fill: none; stroke: #378ADD; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

  .aa-title { font-size: 22px; font-weight: 700; color: #0f1c2e; letter-spacing: -0.5px; margin-bottom: 8px; }
  .aa-sub { font-size: 13.5px; color: #6b7a90; line-height: 1.65; margin-bottom: 2rem; }
  .aa-sub strong { color: #0f1c2e; font-weight: 600; }

  /* SECTION DIVIDER */
  .aa-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }
  .aa-section-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  /* STEPS */
  .aa-steps { display: flex; flex-direction: column; gap: 9px; margin-bottom: 2rem; }
  .aa-step {
    display: flex; align-items: center; gap: 12px;
    padding: 11px 14px;
    background: #f7f9fc; border-radius: 12px;
    border: 1px solid #e8eef7;
  }
  .aa-step-num {
    width: 26px; height: 26px; border-radius: 7px;
    background: #0f1c2e; color: #fff;
    font-size: 11px; font-weight: 700;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .aa-step-text { font-size: 13px; color: #2d3748; font-weight: 500; flex: 1; }
  .aa-step-check {
    width: 24px; height: 24px; border-radius: 7px;
    background: rgba(52,211,153,0.12);
    display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-left: auto;
  }
  .aa-step-check svg { width: 13px; height: 13px; fill: none; stroke: #34d399; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }

  /* SKIP ALERT */
  .aa-skip-alert {
    display: flex; align-items: flex-start; gap: 10px;
    background: rgba(251,191,36,0.08); border: 1px solid rgba(251,191,36,0.3);
    border-radius: 12px; padding: 12px 14px; margin-bottom: 1.5rem;
  }
  .aa-skip-alert-icon { width: 16px; height: 16px; flex-shrink: 0; margin-top: 1px; }
  .aa-skip-alert-text { font-size: 12.5px; color: #92400e; line-height: 1.5; }
  .aa-skip-alert-text strong { color: #78350f; }

  /* BUTTONS */
  .aa-btn {
    width: 100%; height: 50px;
    border: none; border-radius: 14px;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 9px;
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
    margin-bottom: 10px;
  }
  .aa-btn:last-child { margin-bottom: 0; }
  .aa-btn-primary {
    background: #F97316; color: #fff;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
  }
  .aa-btn-primary:hover:not(:disabled) {
    background: #ea6a0a;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
  }
  .aa-btn-outline {
    background: transparent; color: #4a5568;
    border: 1.5px solid #dce4f0;
  }
  .aa-btn-outline:hover:not(:disabled) { border-color: #b8cce8; background: #f7f9fc; }
  .aa-btn:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }

  /* TRUST */
  .aa-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1.25rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .aa-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .aa-split { grid-template-columns: 1fr; }
    .aa-left { padding: 2rem 1.25rem 6rem; }
    .aa-logo { margin-bottom: 1.5rem; }
    .aa-card { padding: 1.75rem 1.5rem; }
  }
  @media (max-width: 480px) {
    .aa-card { padding: 1.5rem 1.25rem; }
    .aa-title { font-size: 20px; }
  }
`;

// ── Icons ──
const IconBolt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" style={{ width: 18, height: 18 }}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </svg>
);
const IconLink = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 26, height: 26 }}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 13, height: 13 }}>
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconSend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 17, height: 17 }}>
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);
const IconSkip = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 17, height: 17 }}>
    <polygon points="5 4 15 12 5 20 5 4"/><line x1="19" y1="5" x2="19" y2="19"/>
  </svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 13, height: 13 }}>
    <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);
const IconWarn = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="aa-skip-alert-icon">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const Spinner = ({ color = '#fff' }) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83">
      <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>
    </path>
  </svg>
);

const STEPS = [
  'Click verify to connect your Account Aggregator',
  'Your financial data is fetched securely',
  'Verification is completed instantly',
];

export default function AggregatorVerify() {
  const [loader, setLoader] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [searchParams] = useSearchParams();
  const leadId = searchParams.get('refstr');

  const navigate = useNavigate();
  const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
  const dispatch = useDispatch();

  const submit = async () => {
    const leadId = Number(customerDetails?.lead_id);
    setLoader(true);
    try {
      const response = await getAggregatorResponse({ leadId: leadId, });
      
      if (response?.data?.apiStatus == 1) {
        toast.success('Verification successful');
        dispatch(updateJourneyEvents({ aggregator_verify: 1, thank_you: 1 }));
        navigate('/journey/congratulations');
      } else {
        setShowButton(true);
        toast.error('Failed to start verification process');
      }
    } catch {
      toast.error('Failed to start verification process');
    } finally {
      setLoader(false);
    }
  };

  const resubmit = async () => {
    setLoader(true);
    try {
      const response = await initiateAccountAggregator({
        profileId: customerDetails?.profileId,
        mobile_number: customerDetails?.mobile,
        skipped_flag: 1,
      });
      if (response?.data?.apiStatus == 1) {
        toast.success('Verification process started');
        dispatch(updateJourneyEvents({ aggregator_verify: 1, upload_documents: 2 }));
      } else {
        toast.error('Failed to start verification process');
      }
    } catch {
      toast.error('Failed to start verification process');
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="aa-page">
        <div className="aa-split">

          {/* ── LEFT ── */}
          <div className="aa-left">
            

            <div className="aa-card">
              <div className="aa-icon-ring"><IconLink /></div>

              <h1 className="aa-title">Account aggregator</h1>
              <p className="aa-sub">
                Click <strong>Verify with Account Aggregator</strong> below to validate your account securely and move ahead with your loan application.
              </p>

              <div className="aa-section-title">How it works</div>
              <div className="aa-steps">
                {STEPS.map((step, i) => (
                  <div className="aa-step" key={i}>
                    <div className="aa-step-num">{i + 1}</div>
                    <span className="aa-step-text">{step}</span>
                    <div className="aa-step-check"><IconCheck /></div>
                  </div>
                ))}
              </div>

              {showButton && (
                <div className="aa-skip-alert">
                  <IconWarn />
                  <div className="aa-skip-alert-text">
                    <strong>Verification failed.</strong> You can skip Account Aggregator and continue with manual document upload instead.
                  </div>
                </div>
              )}

              {showButton ? (
                <button className="aa-btn aa-btn-outline" onClick={resubmit} disabled={loader}>
                  {loader
                    ? <><Spinner color="#4a5568" /> Please wait…</>
                    : <><IconSkip /> Skip account aggregator</>
                  }
                </button>
              ) : (
                <button className="aa-btn aa-btn-primary" onClick={submit} disabled={loader}>
                  {loader
                    ? <><Spinner /> Starting verification…</>
                    : <><IconSend /> Verify with account aggregator</>
                  }
                </button>
              )}

              <div className="aa-trust">
                <IconLock />
                256-bit SSL encrypted
                <span className="aa-trust-sep" />
                Your data is private
                <span className="aa-trust-sep" />
                RBI compliant
              </div>
            </div>
          </div>

          {/* ── RIGHT: reusable component ── */}
          <JourneyRightPanel />

        </div>
      </div>
      <MobileNav />
    </>
  );
}